import {IssueTimelineLoading} from './IssueTimelineLoading'
import {IssueBodyLoading} from '@github-ui/issue-body/IssueBodyLoading'
import {HeaderLoading} from './header/HeaderLoading'
import {Box} from '@primer/react'
import {SidebarSectionsLoading} from './sections/SidebarSectionsLoading'
import {useRef} from 'react'
import {useContainerBreakpoint} from '@github-ui/use-container-breakpoint'
import {ContentWrapper} from './ContentWrapper'

export const IssueViewerLoading = () => {
  const issueViewerContainerRef = useRef<HTMLDivElement>(null)

  const breakpoint = useContainerBreakpoint(issueViewerContainerRef.current)
  return (
    <ContentWrapper>
      <Box
        ref={issueViewerContainerRef}
        sx={{
          display: 'flex',
          flex: 'auto',
          flexDirection: 'column',
          justifyContent: 'stretch',
          overflowY: 'auto',
          mt: 3,
        }}
      >
        <Box
          sx={{
            marginBottom: '32px',
          }}
        >
          <HeaderLoading />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flex: 'auto',
            flexDirection: breakpoint(['column', 'column', 'row', 'row']),
            justifyContent: 'stretch',
            overflowY: 'auto',
          }}
        >
          <Box
            sx={{
              width: breakpoint(['100%', '100%', '67%', '67%']),
              backgroundColor: 'canvas.default',
              zIndex: 1,
            }}
          >
            <Box>
              <IssueBodyLoading />
            </Box>
            <Box>
              <Box
                sx={{
                  mb: 3,
                }}
              >
                <IssueTimelineLoading />
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              width: breakpoint(['100%', '100%', '33%', '33%']),
              pl: 3,
            }}
          >
            <SidebarSectionsLoading />
          </Box>
        </Box>
      </Box>
    </ContentWrapper>
  )
}

try{ IssueViewerLoading.displayName ||= 'IssueViewerLoading' } catch {}